import handleYoutubeVideo from './youtube-video';
import handleVimeoVideo from './vimeo-video';

const handleVideoInSlider = () => {
  const $video = $('.js-slider .video');

  if ($video.length === 0) {
    return;
  }

  $('.js-slider').each(function() {
    const $this = $(this);
    const $currentSlideVideo = $this.find('.slick-current .video');

    if (! $currentSlideVideo.hasClass('video--init')) {
      const $currentVideoInner = $currentSlideVideo.find('.video__inner');

      $currentSlideVideo.trigger('click');

      $currentVideoInner.attr('id', $currentVideoInner.data('id'));

      if ($currentSlideVideo.hasClass('video--youtube')) {
        handleYoutubeVideo($currentSlideVideo);
      } else if ($currentSlideVideo.hasClass('video--vimeo')) {
        handleVimeoVideo($currentSlideVideo);
      }

      $currentSlideVideo.addClass('video--init');
    }
  });

  $('.js-slider').on('afterChange', function(event, slick) {
    slick.$slides.each(function() {
      const $this = $(this);

      if ($this.hasClass('slick-current')) {
        const $video = $this.find('.video');

        if (! $video.hasClass('video--init')) {
          const $videoInner = $video.find('.video__inner');

          $video.trigger('click');

          $videoInner.attr('id', $videoInner.data('id'));

          if ($video.hasClass('video--youtube')) {
            handleYoutubeVideo($video);
          } else if ($video.hasClass('video--vimeo')) {
            handleVimeoVideo($video);
          }

          $video.addClass('video--init');
        }
      }
    });
  });
}

handleVideoInSlider();
